<template>
  <div class="placing-variants-tooltip paragraph-xs text-secondary">
    <div v-if="placingVariant?.baseSeats.length">
      <div class="font-600 mb-1">На основных местах</div>
      <ul class="ul-list">
        <li v-for="(seat, index) in placingVariant.baseSeats" :key="index">
          {{ seat.seats }}
          {{
            seat.touristType.ageCategory
              ? `${declensionString(seat.seats, ['ребенок', 'ребенка', 'детей'])} с ${seat.touristType.ageCategory.from} до ${seat.touristType.ageCategory.to}`
              : declensionString(seat.seats, ['взрослый', 'взрослых', 'взрослых'])
          }}
        </li>
      </ul>
    </div>
    <div v-if="placingVariant?.extSeats.length">
      <div class="font-600 mb-1">На дополнительных местах</div>
      <ul class="ul-list">
        <li v-for="(seat, index) in placingVariant.extSeats" :key="index">
          {{ seat.seats }}
          {{
            seat.touristType.ageCategory
              ? `${declensionString(seat.seats, ['ребенок', 'ребенка', 'детей'])} с ${seat.touristType.ageCategory.from} до ${seat.touristType.ageCategory.to}`
              : declensionString(seat.seats, ['взрослый', 'взрослых', 'взрослых'])
          }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PlacingVariantSeatsType } from '@/parts/tariffs/types/tariffs';
import { declensionString } from '@/core/utils/string';

defineProps<{
  placingVariant?: PlacingVariantSeatsType;
}>();
</script>

<style scoped lang="scss">
.placing-variants-tooltip {
  display: flex;
  flex-direction: column;

  row-gap: 8px;
}
</style>
